export default __webpack_public_path__ + "static/media/ssl_img.d8d98403.png";